import { builderFetch } from '../../utilities';

// Translatable strings
const strings = UncannyAutomator._core.i18n.core.runNow;

/**
 * Runs the recipe on demand
 *
 * @return {Promise} The apiFetch promise
 */
const runRecipe = () => {
	// Run the recipe
	return builderFetch( {
		endpoint: `run-now/start/${ UncannyAutomator._recipe.recipe_id }`,
		method: 'POST',
		snackbar: {
			loading: strings.starting,
			success: strings.started,
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( 'uap/builder/core/run-recipe' ) );
		}

		return response;
	} );;
}

export default runRecipe;
